import fp from 'lodash/fp'

export const getApolloClient = fp.prop('apolloProvider.defaultClient')
